import Analytics from '../helpers/analytics';
import Utilities from '../helpers/utilities';
import 'jquery-mask-plugin';

export default class {

    constructor() {
        this.firstLoad = true;
        this.analytics = new Analytics();
        this.utilities = new Utilities();

        if (this.utilities.smartLoad('.apply-select-role-form')) {
            this.applySelectRoleForm = $('.apply-select-role-form');            
            this.applyingFor = $('#ApplyingFor');
            this.applyingFor2 = $('#ApplyingFor2');
            this.applyingFor3 = $('#ApplyingFor3');
            this.applyingFor.prop('disabled', true);
            this.applyingFor2.prop('disabled', true);
            this.applyingFor3.prop('disabled', true);
            this.applyingForFav = $('#ApplyingForFav');
            this.applyingForFav2 = $('#ApplyingForFav2');
            this.applyingForFav3 = $('#ApplyingForFav3');
            this.applyingForFav.prop('disabled', true);
            this.applyingForFav2.prop('disabled', true);
            this.applyingForFav3.prop('disabled', true);
            this.setDropdownEvents();
            this.applyForm20();
            this.roleKnownOrNot();
            this.favOrNot();
            this.buildFavourites();
            this.timeChange();
            this.favTimeChange();
            this.submitButtonState();
        }
    }
    

    buildFavourites() { 

        let cookie = this.utilities.getCookie('favourites');
        let favsExist = false;
    
        if (cookie !== undefined && cookie.length > 0) {
    
            favsExist = true;
            let elString = '<option value="" data-isregular="True" data-isreserve="True">Please select...</option>';

            // Build a set of valid role values from the existing ApplyingFor dropdown
            const validRolesReg = new Set();
            const validRolesRes = new Set();
            this.applyingFor.find('option').each(function() {
                const $option = $(this);
                const val = $option.attr('value');
                if (val) {
                    const trimmedVal = val.trim();
                    const isRegular = $option.data('isregular') == "True";
                    const isReserve = $option.data('isreserve') == "True";
                    if (isRegular) {
                        validRolesReg.add(trimmedVal);
                    }
                    if (isReserve) {
                        validRolesRes.add(trimmedVal);
                    }
                }
            });
            
            let groupedOptions = {};
            
            cookie.split(',').sort().forEach((fav, i) => {
                let attr = fav.replace('¬',',').split('|');
                let group = attr[0];
                let roleName = attr[1];
                let roleValue = `${attr[2]}|${attr[3]}`;
                let reg = (attr[5] && attr[6] && validRolesReg.has(roleValue)) ? "True" : "False";
                let res = (attr[7] && attr[8] && validRolesRes.has(roleValue)) ? "True" : "False";
    
                if (!groupedOptions[group]) {
                    groupedOptions[group] = [];
                }
    
                groupedOptions[group].push(
                    `<option value="${roleValue}" data-isregular="${reg}" data-isreserve="${res}">${roleName}</option>`
                );
            });
    
            // Now actually build the final elString
            for (const [group, options] of Object.entries(groupedOptions)) {
                if (options.length > 0) {
                    elString += `<optgroup label="${group}">`;
                    elString += options.join('');
                    elString += `</optgroup>`;
                }
            }
    
            this.applyingForFav.append(elString);
            this.applyingForFav2.append(elString);
            this.applyingForFav3.append(elString);
        }
    
        if (favsExist) {
            $('.favroles-exist').show();
            $('.favroles-dontexist').hide();            
        } else {
            $('.favroles-exist').hide();
            $('.favroles-dontexist').show();
        }
    
        $('.select-regorres-fav').on('click', (e) => {
            e.preventDefault();
            var $selection = $(e.currentTarget);
            $('.select-regorres-fav').removeClass('active');
            $selection.addClass('active');
        });
    }
    
    setMultiApplyForFavs() {
        $('#MultiApplyFor').val('');

        let selectedTime = $('.select-regorres-fav label.active').data('time');

        var value = this.applyingForFav.val() + '|' + selectedTime;
        if (this.applyingForFav2.val() != '') {
            value += ',' + this.applyingForFav2.val() + '|' + selectedTime;
        }
        if (this.applyingForFav3.val() != '') {
            value += ',' + this.applyingForFav3.val() + '|' + selectedTime;
        }
        $('#MultiApplyFor').val(value);
    }


    setMultiApplyForNonfavs() {
        $('#MultiApplyFor').val('');
        let selectedTime = $('.select-regorres-nonfav label.active').data('time');

        let value = this.applyingFor.val() + '|' + selectedTime;
        if (this.applyingFor2.val() != '') {
            value += ',' + this.applyingFor2.val() + '|' + selectedTime;
        }
        if (this.applyingFor3.val() != '') {
            value += ',' + this.applyingFor3.val() + '|' + selectedTime;
        }
        $('#MultiApplyFor').val(value);
    }


    favOrNot() {
        $('input[name="favornot"]').on('change', (e)=> {
            var $target = $(e.currentTarget);
            $('.select-favornot label').removeClass('active');
            $target.closest('label').addClass('active');
            $('.apply-select-notfavourites').hide();            
            $('.apply-select-favourites').hide();                
            if ($target.val() == 'Yes') {                
                $('.apply-select-favourites').show();
            } else {               
                $('.apply-select-notfavourites').show();                
            }
        });
    }

    applyForm20() {       
        this.submitEvent();        
    }

    submitButtonState() {
        $('#roleTbd').on('change', function() {
            var submitButton = $(this).closest('form').find(':submit');
            if (this.checked) {
                submitButton.prop('disabled', false);
            } else {
                submitButton.prop('disabled', true);
            }
        });

        this.applyingFor.on('change', function() {
            var submitButton = $(this).closest('form').find(':submit');
            if ($(this).val() != '') {
                submitButton.prop('disabled', false);
            } else {
                submitButton.prop('disabled', true);
            }
        });

        this.applyingForFav.on('change', function() {
            var submitButton = $(this).closest('form').find(':submit');
            if ($(this).val() != '') {
                submitButton.prop('disabled', false);
            } else {
                submitButton.prop('disabled', true);
            }
        });
    }

    roleKnownOrNot() {
    
        if ($('.apply-select-roleknownornot').find('.question-text').text() == '') {
            $('.apply-select-roleknownornot').hide();
        } else {
            $('.apply-select-roleknownornot').show();
        }

        const roleKnownFollowingForm = $('.apply-select-knownrole');
        const roleUnknownFollowingForm = $('.apply-select-unknownrole');
            
        $('input[name="roleknown"]').on('change', (e)=> {
            var $target = $(e.currentTarget);            
            $('.select-roleknown label').removeClass('active');
            $target.closest('label').addClass('active');
            roleKnownFollowingForm.hide();                        
            roleUnknownFollowingForm.hide();
            if ($target.val() === 'No') {
                roleUnknownFollowingForm.show();
            } else {
                roleKnownFollowingForm.show();
            }
        });
    }

    favTimeChange() {
        $('.select-regorres-fav label').on('click', (e) => {
            const $label = $(e.currentTarget);
            $('.select-regorres-fav label').removeClass('active');
            $label.addClass('active');

            const time = $label.data('time');

            this.applyingForFav.prop('disabled', false);
            this.applyingForFav2.prop('disabled', false);
            this.applyingForFav3.prop('disabled', false);

            this.updateFavDropdowns(time);
        });
    }

    timeChange() {

        const urlVrs = this.utilities.getUrlVars();  

        if (urlVrs !== undefined) {
            const timeSelected = urlVrs['time'];
            if (timeSelected !== undefined && timeSelected === 'regular') {
                $('.regular-time').addClass('active');
                this.applySelectRoleForm.find('.time-checkbox').val(timeSelected);                
            }
        }

        var selectForm = $('.apply-select-role-form');
        var action = selectForm.attr('action');

        const roleTypeButton = this.applySelectRoleForm.find('.select-regorres-nonfav label');

        roleTypeButton.on('click', (e) => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const time = $target.data('time');

            roleTypeButton.removeClass('active');
            $target.addClass('active');

            this.applySelectRoleForm.find('.time-checkbox').val(time);

            selectForm.attr('action', `${action}?time=${time}`);

            this.applyingFor.removeClass('form-disabled').prop('disabled', false);
            this.applyingFor2.removeClass('form-disabled').prop('disabled', false);
            this.applyingFor3.removeClass('form-disabled').prop('disabled', false);

            this.updateDropdowns();
        });
    }

    updateFavDropdowns(selectedTime) {
        let isRegulars = selectedTime === 'regular';
        let isReserves = selectedTime === 'reserve';

        $('.gtm-select-apply-for-fav').each(function() {
            $(this).find('optgroup').each(function() {
                let optgroup = $(this);
                let show = false;
                optgroup.find('option').each(function() {
                    let option = $(this);
                    option.prop('selected', false);
                    if ((isRegulars && option.data('isregular') == 'True') ||
                        (isReserves && option.data('isreserve') == 'True')) {
                        show = true;
                        option.show();
                    } else {
                        option.hide();
                    }
                });
                if (show) {
                    optgroup.show();
                } else {
                    optgroup.hide();
                }
            });
        });
    }


    updateDropdowns() {
        let isRegulars = $('.regular-time').hasClass('active');
        let isReserves = $('.reserve-time').hasClass('active');        
        $('.gtm-select-apply-for').each(function() {
            $(this).find('optgroup').each(function() {
                let optgroup = $(this);               
                let show = false;
                optgroup.find('option').each(function() {
                    let option = $(this);
                    option.prop('selected', false);
                    if ((isRegulars && option.data('isregular') == 'True') || (isReserves && option.data('isreserve') == 'True')) {
                        show = true;
                        option.show();
                    } else {
                        option.hide();
                    }
                });
                if (show) {
                    optgroup.show();
                } else {
                    optgroup.hide();
                }
            });
        });
    }

    setDropdownEvents() {
        $('.gtm-select-apply-for').on('change', (e) => {
            this.enableDropdownOptions();
        });
        $('.gtm-select-apply-for-fav').on('change', (e) => {
            this.enableDropdownOptionsFav();
        });
    }

    enableDropdownOptions() {
        var self = this;

        this.applyingFor.find('option').each(function() {
            $(this).prop('disabled', (this.value != '' && (this.value == self.applyingFor2.val() || this.value == self.applyingFor3.val())));
        });

        this.applyingFor2.find('option').each(function() {
            $(this).prop('disabled', (this.value != '' && (this.value == self.applyingFor.val() || this.value == self.applyingFor3.val())));
        });

        this.applyingFor3.find('option').each(function() {
            $(this).prop('disabled', (this.value != '' && (this.value == self.applyingFor.val() || this.value == self.applyingFor2.val())));
        });
    }

    enableDropdownOptionsFav() {
        var self = this;

        this.applyingForFav.find('option').each(function() {
            $(this).prop('disabled', (this.value != '' && (this.value == self.applyingForFav2.val() || this.value == self.applyingForFav3.val())));
        });

        this.applyingForFav2.find('option').each(function() {
            $(this).prop('disabled', (this.value != '' && (this.value == self.applyingForFav.val() || this.value == self.applyingForFav3.val())));
        });
        
        this.applyingForFav3.find('option').each(function() {
            $(this).prop('disabled', (this.value != '' && (this.value == self.applyingForFav.val() || this.value == self.applyingForFav2.val())));
        });
    }

    submitEvent() {

        this.applySelectRoleForm.on('submit', (e) => {

            e.preventDefault();

            const time = this.applySelectRoleForm.find('.time-checkbox').val();
            if (time !== undefined && time !== '' && time !== null) {       
                if (time === 'reserve') {
                    const label = 'Spare time reserve';
                    this.analytics.dataLayer('iproSpareTime', 'Choose your role', label, 'Form submit');
                }
            }

            if ($('.select-favornot label.active input').val() === 'Yes') {
                this.setMultiApplyForFavs();
            } else {
                this.setMultiApplyForNonfavs();
            }

            e.currentTarget.submit();
        })        
    }
}